// Not a secret: it only tells the destination region which identity provider to send the user to,
// so an active identity provider session logs them in without showing the provider picker.
var LOGIN_PROVIDER_PARAM = 'loginProvider';
var add = function add(searchParams, provider) {
    if (provider) {
        searchParams.set(LOGIN_PROVIDER_PARAM, provider);
    }
};
/**
 * Reads the hint and removes it from the current URL, so it never ends up in a redirect URI.
 */ var consume = function consume() {
    var url = new URL(window.location.href);
    var provider = url.searchParams.get(LOGIN_PROVIDER_PARAM);
    if (provider !== null) {
        url.searchParams.delete(LOGIN_PROVIDER_PARAM);
        window.history.replaceState(window.history.state, '', url.toString());
    }
    return provider;
};
export var LoginProviderHint = {
    add: add,
    consume: consume
};

//# sourceMappingURL=LoginProviderHint.js.map